<template>
  <RecordingConsentScreen
    v-if="isRecordingConsentScreenVisible"
    :shouldCloseWindow="false"
    :agree-btn-text="$t('recording_consent_modal.join_to_meeting_button')"
    :leave-btn-text="$t('recording_consent_modal.leave_button')"
  />
  <MobileAppScreen v-else-if="isAppReady" />
  <MobileEntranceScreen v-else-if="showEntranceScreen" />
  <LoadingScreen v-else />
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import MobileAppScreen from '@/views/mobile/MobileAppScreen';
import LoadingScreen from '@/views/LoadingScreen.vue';
import MobileEntranceScreen from '@/views/mobile/MobileEntranceScreen.vue';
import RecordingConsentScreen from '@/views/RecordingConsentScreen.vue';

export default {
  name: 'MobileHome',

  components: {
    RecordingConsentScreen,
    MobileAppScreen,
    LoadingScreen,
    MobileEntranceScreen
  },

  computed: {
    ...mapState([
      'showEntranceScreen',
      'isRecordingConsentScreenVisible',
      'showPreJoinScreen'
    ]),
    ...mapGetters([
      'isAppReady',
      'isRecordingConsentGiven',
      'isJoinedDuringActiveRecording',
      'shouldShowNoPreJoinRecordingConsentScreen'
    ]),
    ...mapGetters('recordings', ['isRecording', 'isRecordingOwner'])
  },

  watch: {
    shouldShowNoPreJoinRecordingConsentScreen: {
      handler(status) {
        this.setIsRecordingConsentScreenVisible(status);
      },
      immediate: true
    }
  },

  created() {
    this.initApp(this.$route.query);
  },

  methods: {
    ...mapActions([
      'initApp',
      'setIsJoinedDuringActiveRecording',
      'setIsRecordingConsentScreenVisible'
    ])
  }
};
</script>
